import { AppRoutePaths } from '@/routing/route_paths'
import {
  configureSliceForInsertStudent,
  resetOCRAttempts,
} from '@/storage/applications/familyApplicationSlice'
import { selectProgramSettings } from '@/storage/program_settings/programSettingsSlice'
import { AppDispatch } from '@/storage/store'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import {
  formatProgramWindowDate,
  getProgramEndTimeInUsersTimezone,
  getProgramStartTimeInUsersTimezone,
  isApplicationWindowOpen,
} from '../../utils/dates/dates.utils'
import { Button, buttonVariants } from '../Button'

function AddStudentButton() {
  const { t } = useTranslation()
  const location = useLocation()
  const StoreDispatch = useDispatch<AppDispatch>()
  const programSettings = useSelector(selectProgramSettings)

  function handleAddStudentClick() {
    StoreDispatch(configureSliceForInsertStudent())
    StoreDispatch(resetOCRAttempts())
  }

  const isNewApplicationOpen = isApplicationWindowOpen(programSettings)

  if (isNewApplicationOpen) {
    return (
      <Link
        onClick={handleAddStudentClick}
        to={AppRoutePaths.family_application.student_details.index}
        className={buttonVariants({ variant: 'primary' })}
      >
        {t('add_student')}
      </Link>
    )
  }

  const newApplicantStartDate = formatProgramWindowDate(
    getProgramStartTimeInUsersTimezone(
      programSettings.new_application_start_date,
      programSettings.global_timezone_code
    )
  )
  

  const newApplicantEndDate = formatProgramWindowDate(
    getProgramEndTimeInUsersTimezone(
      programSettings.new_application_end_date,
      programSettings.global_timezone_code
    )
  )

  // Need to fix this eventually.
  // it works, but it doesn't make sense to render this component like this
  // but tight deadlines and change of requirements, so had to make a quick fix.
  if (
    location.pathname.includes(
      AppRoutePaths.family_application.student_details.additional_student
    )
  )
    return (
      <div className="text-gray-600 text-sm">
        <div>
          <Button disabled={true} variant="primary" className="w-full mb-4">
            {t('add_student')}
          </Button>
        </div>
        New students can be added between {newApplicantStartDate} and{' '}
        {newApplicantEndDate}
      </div>
    )

  return null
}

export default AddStudentButton
